// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1v_7q","fullScreen":"style_fullScreen__36qJD","hidden":"style_hidden__1I71D"};